import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

function getContainer(container) {
  return ReactDOM.findDOMNode(typeof container === 'function' ? container() : container);
}

export var Portal =
/*#__PURE__*/
React.forwardRef(function Portal(_ref, ref) {
  var children = _ref.children,
      container = _ref.container,
      _ref$disablePortal = _ref.disablePortal,
      disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
      onRendered = _ref.onRendered;

  var _React$useState = React.useState(getContainer(container) || document.body),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mountNode = _React$useState2[0],
      setMountNode = _React$useState2[1];

  useEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEffect(function () {
    if (mountNode && !disablePortal && ref) {
      ref.current = mountNode;
      return function () {
        ref.current = null;
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if (
    /*#__PURE__*/
    React.isValidElement(children)) {
      return (
        /*#__PURE__*/
        React.cloneElement(children)
      );
    }

    return children;
  }

  return mountNode ?
  /*#__PURE__*/
  ReactDOM.createPortal(children, mountNode) : mountNode;
});